import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["explanationSelector"]

  changeExplanation() {
    window.location.href = this.explanationSelectorTarget.value
  }
}
